import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

const APP_STORE_URL = 'https://apps.apple.com/cz/app/mr-parkit/id6615079570'

export default function UnsupportedIosAppCheckout({ onBack }: { onBack?: () => void }) {
    const { t, i18n } = useTranslation()
    const locale = (i18n.resolvedLanguage || i18n.language).split(/[-_]/)[0]

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#F2F2F2',
            px: 2,
            py: 4,
        }}>
            <Box sx={{
                width: '100%',
                maxWidth: 520,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                borderRadius: '18px',
                backgroundColor: 'white',
                p: 4,
                textAlign: 'center',
            }}>
                <Typography level="h3">
                    {t('checkout.unsupportedIosApp.title')}
                </Typography>
                <Typography level="body-md">
                    {t('checkout.unsupportedIosApp.description')}
                </Typography>
                <Button
                    component="a"
                    href={`${APP_STORE_URL}?platform=iphone&l=${encodeURIComponent(locale)}`}
                    variant="solid"
                    sx={{
                        fontSize: '15px',
                        padding: '0.875rem 1.25rem',
                        borderRadius: '7px',
                        backgroundColor: 'customBlack.main',
                    }}
                >
                    {t('checkout.unsupportedIosApp.updateApp')}
                </Button>
                {onBack ? (
                    <Button
                        variant="plain"
                        onClick={onBack}
                        sx={{ color: 'black' }}
                    >
                        {t('checkout.actions.back')}
                    </Button>
                ) : null}
            </Box>
        </Box>
    )
}
